import React, { Component } from "react";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../modules/simpleTextArea";
import { ACTIVITY_TYPE } from "../../../common/Constants";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleCamera from "../../../../modules/SimpleCamera";

class CrmMember extends Component {
  render() {
    const { options, activityType, controls, setValue, errors, box } =
      this.props;
    const isReadOnly =
      activityType !== ACTIVITY_TYPE.CREATE &&
      activityType !== ACTIVITY_TYPE.UPDATE;
      
    return (
      <React.Fragment>
        <div className="grid grid-3x gap-20px">
          <div id="grid-1">
            <SimpleInput
              name="customerId"
              label="Member ID"
              value={controls?.customerId?.value || ""}
              readOnly
            />
            <SimpleDDL
              id="select_options_member_level"
              box="search"
              name="memberLevel"
              label="Member Level"
              readOnly
              value={controls?.memberLevel?.value || null}
              options={options?.memberLevelOptions || []}
              onChange={(value, { name }) => setValue(name, value)}
            />
            <SimpleDDL
              id="select_options_loyalty_level"
              box="search"
              name="loyaltyLevel"
              label="Loyalty Level"
              readOnly
              value={controls?.loyaltyLevel?.value || null}
              options={options?.loyaltyLevelOptions || []}
              onChange={(value, { name }) => setValue(name, value)}
            />
            <SimpleDDL
              id="select_options_special_category"
              box="search"
              name="specialCategory"
              label="Kategori Khusus"
              readOnly
              value={controls?.specialCategory?.value || null}
              options={options?.specialCategoryOptions || []}
              onChange={(value, { name }) => setValue(name, value)}
            />
            {box === "CDB" && (
              <SimpleCamera
                key="upload_foto_ktp"
                id="upload_foto_ktp"
                name="photoKTP"
                mandatory
                errorMessage={errors?.photoKTP}
                disabled={isReadOnly}
                enableUpload={true}
                label="Foto KTP"
                value={controls?.photoKTP?.value}
                onChange={(value, name) => setValue(name, value)}
              />
            )}
          </div>
          <div id="grid-2">
            <SimpleTextArea
              id="text_special_notes"
              name="specialNotes"
              label="Catatan Khusus"
              value={controls?.specialNotes?.value}
              readOnly={isReadOnly}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
            {box === "CDB" && (
              <SimpleCamera
                key="upload_foto_kk"
                id="upload_foto_kk"
                name="photoKK"
                disabled={isReadOnly}
                enableUpload={true}
                label="Foto KK"
                value={controls?.photoKK?.value}
                onChange={(value, name) => setValue(name, value)}
              />
            )}
          </div>
          <div id="grid-3">
            <SimpleCamera
              key="upload_profile_picture"
              id="upload_profile_picture"
              name="photoCustomerUrl"
              errorMessage={errors?.photoCustomerUrl}
              disabled={isReadOnly}
              enableUpload={true}
              label="Profile Picture"
              value={controls?.photoCustomerUrl?.value}
              onChange={(value, name) => setValue(name, value)}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default CrmMember;
